import resources from "./resources";

const ParamConstants = {
  imageParamKeys: ["cover_image_url", "image_url"],
  resourcesWithImageParams: [
    resources.TOPIC.url,
    resources.CONTENT.url,
    resources.CONTENT_ITEMS.url,
  ],
};

export const CONTENT_PARAM_LOCAL = "RaStore.content-admin/content.listParams";

export default ParamConstants;
